const events = require('../../scripts/events')

const flattenMods = (options, config, pre_select_default_modifiers) => {
  const $utils = $nuxt.$store.$utils
  // $utils.log('** flattenMods options', options)
  options.map((o) => {
    if (o.mods && config.choices.find((c) => c.id === o.choice_id)) {
      o.mods.map((m) => {
        if (m.meta && 'modgroup-formation-name' in m.meta) {
          // $utils.log('** flattenMods adds:', m.name, ' - ', m.options[0].name, 'default:', m.options[0].default)

          // checks pre_select_default_modifiers boolean in the client app.json - it defauls to false
          if (pre_select_default_modifiers) {
            if (!config.choices.find((c) => c.id === m.options[0].choice_id) && m.options[0].default) {
              config.choices.push({ ...m.options[0], id: m.options[0].choice_id, quantity: 1 })
            }
          } else {
            if (!config.choices.find((c) => c.id === m.options[0].choice_id)) {
              config.choices.push({ ...m.options[0], id: m.options[0].choice_id, quantity: 1 })
            }
          }

          config.mods.push(m)
        } else if (m.meta && 'button-group' in m.meta && m.meta['button-group'] === 'true' && m.options.length === 3) {
          $utils.log('display as button group')
        } else if (m.meta && 'button-group' in m.meta && m.meta['button-group'] === 'true' && 'button-group-label' in m.meta && 'button-group-style' in m.meta && m.meta['button-group-style'] === 'super') {
          $utils.log('display as super', m.meta['button-group-label'])
          config.mods.push(m)
        } else {
          config.mods.push(m)
        }
        config = flattenMods(m.options, config, pre_select_default_modifiers)
      })
    }
  })
  return config
}

const findMod = (choice, mods = []) => {
  // const $utils = $nuxt.$store.$utils
  let mod = null
  mods.map((m) => {
    m.options.map((o) => {
      if (!mod) {
        if (choice.id === o.choice_id) {
          mod = m
        } else if (o.mods) {
          mod = findMod(choice, o.mods)
        }
      }
    })
  })
  return mod
}

const resetMods = (choices, option) => {
  const $utils = $nuxt.$store.$utils
  $utils.log('check:', option.name)
  const choiceFound = choices.find((c) => c.id === option.choice_id)
  if (choiceFound) {
    $utils.log('remove:', option.name)
    choices.splice(choices.indexOf(choiceFound), 1)

    if (option.mods) {
      option.mods.map((m) => {
        m.options.map((o) => {
          choices = resetMods(choices, o)
        })
      })
    }
  }
  return choices
}

/**
 * @deprecated
 */
const preSelectMods = (choices, mods = []) => {
  const $utils = $nuxt.$store.$utils
  mods.forEach((mod) => {
    const defaultOption = mod.options.find((option) => option.default)
    const anyChoiceFound = mod.options.find((option) => {
      return choices.find((c) => c.id === option.choice_id)
    })
    if (!anyChoiceFound && defaultOption) {
      $utils.log('pre-select:', defaultOption.name)
      choices.push({ ...defaultOption, id: defaultOption.choice_id, quantity: 1 })
    }
    mod.options.forEach((option) => preSelectMods(choices, option.mods))
  })
  return choices
}

const validateMods = (mods = [], choices, errors = []) => {
  const $utils = $nuxt.$store.$utils
  mods.map((m) => {
    const mandatory = m.selects.mandatory
    const min = m.selects.min
    const max = m.selects.max
    let count = 0
    m.options.map((o) => {
      const option = choices.find((c) => c.id === o.choice_id)
      if (option) {
        count += option.quantity
        if (o.mods) {
          errors = validateMods(o.mods, choices, errors)
        }
      }
    })
    if (mandatory && !min && !max && count !== 1) {
      errors.push(`${m.name} is required.`)
    } else if (count < min) {
      errors.push(`${m.name} requires a minimum of ${min} selections.`)
    }
    $utils.log(m.name, '; count:', count, ', min:', min, ', max:', max)
  })

  return errors
}

module.exports = {
  processMods: async ({ rootState, state, commit }) => {
    const $utils = $nuxt.$store.$utils
    // checks pre_select_default_modifiers boolean in the client app.json - it defauls to false
    const pre_select_default_modifiers = rootState.appInfo && rootState.appInfo.pre_select_default_modifiers
    // const flatten = typeof options.flatten === 'undefined' ? options.flatten : true
    let modifiers = $utils.copy(state.data.mods || [])
    let config = {
      choices: $utils.copy(state.choices),
      mods: [],
      groupMods: [],
    }
    modifiers.map((m) => {
      config.mods.push(m)
      // if(flatten) {
      config = flattenMods(m.options, config, pre_select_default_modifiers)
      // }
    })
    // $utils.log(config)
    commit('setMods', config.mods)
    commit('setChoices', config.choices)
  },
  selectMod: async ({ state, commit, dispatch }, choice) => {
    const { isEdit } = choice
    const $utils = $nuxt.$store.$utils
    let choices = $utils.copy(state.choices)
    const mod = findMod(choice, state.data.mods)
    const choiceFound = choices.find((c) => c.id === choice.id)
    $utils.log('mod:', mod)
    // don not reset the mods if it is in edition mode
    if (mod.selects.mandatory && !mod.selects.min && !mod.selects.max && !isEdit) {
      mod.options.map((o) => {
        choices = resetMods(choices, o)
      })
      choices.push(choice)
    } else {
      const min = mod.selects.min
      const max = mod.selects.max
      let count = 0
      if (mod.selects.counter) {
        count = choice.quantity
        choice.cost = choice.cost * choice.quantity
      } else {
        count += choice.quantity
        choice.cost = choice.cost * choice.quantity
        mod.options.map((o) => {
          const option = choices.find((c) => c.id === o.choice_id)
          if (option) {
            count += option.quantity
          }
        })
      }
      $utils.log('count:', count, ', min:', min, ', max:', max)
      if (choiceFound) {
        const index = choices.indexOf(choiceFound)
        if (choice.quantity === 0) {
          choices = resetMods(choices, choice)
        } else if (count <= max) {
          choices.splice(index, 1, choice)
        } else {
          $utils.log('mod IS previously selected, count exceeds maximum')
        }
      } else {
        if (mod.selects.counter && count === 0) {
          $utils.log('quantity 0 not allowed')
          return
        }
        if (!max || count <= max) {
          choices.push(choice)
        } else {
          $utils.log('mod NOT previously selected, count exceeds maximum')
          return
        }
      }
    }
    $utils.log('new choices:', choices)
    commit('setChoices', choices)
    dispatch('processMods')
    return true
  },
  removeMod: async ({ state, commit, dispatch }, choice) => {
    const $utils = $nuxt.$store.$utils
    let choices = $utils.copy(state.choices)
    const choiceIdxFound = choices.findIndex((c) => c.id === choice.id)
    if (choiceIdxFound >= 0) {
      if (choice.mods && choice.mods.length > 0) {
        choices = resetMods(choices, choice)
      } else {
        choices.splice(choiceIdxFound, 1)
      }
      commit('setChoices', choices)
      dispatch('processMods')
    } else {
      $utils.log('choice NOT found')
    }
  },
  removeAllMods: async ({ commit }) => {
    commit('setChoices', [])
  },
  quickAddProduct: async ({ state, rootState, dispatch }, product) => {
    if (!rootState.cart) {
      return await dispatch('addProduct', product)
    }

    if (!Array.isArray(rootState.cart.products)) {
      return await dispatch('addProduct', product)
    }

    const productFound = rootState.cart.products.find((p) => p.product_id === product.product_id)
    if (productFound) {
      const updatedProd = {
        id: productFound.id,
        quantity: productFound.quantity + state.quantity ? state.quantity : 1,
        choices: [],
      }
      productFound.choices.map((c) => {
        updatedProd.choices.push({
          id: c.option_id,
          quantity: 1,
        })
      })
      return await dispatch('updateProduct', updatedProd)
    } else {
      return await dispatch('addProduct', product)
    }
  },
  addProduct: async ({ state, rootState, commit, dispatch }, product) => {
    const $utils = $nuxt.$store.$utils
    if (state.data) {
      let choices = $utils.copy(state.choices)
      let mods = state.data.mods
      const errors = validateMods(mods, choices)
      $utils.log(choices)
      if (errors.length > 0) {
        commit('setErrors', errors, { root: true })
        return false
      }
    }

    commit('setLoading', true, { root: true })
    if (!rootState.cart) {
      if (!(await dispatch('createCart', false, { root: true }))) {
        commit('setLoading', false, { root: true })
      }
    }

    let payload = {}
    // quick add
    if (product && product.product_id) {
      payload.id = product.product_id
      payload.quantity = state.quantity ? state.quantity : 1
    } else {
      payload.id = state.data.product_id
      payload.quantity = state.quantity
      payload.choices = state.choices.map((c) => {
        return {
          id: c.id,
          quantity: c.quantity,
        }
      })
    }

    if (state.recipient) {
      payload.recipient = state.recipient
    }

    if (state.instructions) {
      payload.instructions = state.instructions
    }

    let headers = {}
    if (rootState.channel === 'catering') {
      headers = {
        client_sub: 'catering',
      }
    }

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'post',
        url: `carts/${rootState.cart.id}/products`,
        data: payload,
        headers,
      }
      const response = await dispatch('sendRequest', config, { root: true })
      if (response.status === 'ok') {
        response.data.type = rootState.channel && rootState.channel !== 'default' ? rootState.channel : 'mealtime'
        const cart = response.data
        commit('setCart', cart, { root: true })
        commit('setAdded', true)
        let payload = product || state.data
        payload.quantity = state.quantity
        let tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
        // events.pushEvent('add_to_cart', payload, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.menu, rootState.channel)
        commit('setLoading', false, { root: true })
        dispatch('checkout/removeUpsell', payload, { root: true })
        // reset the quantity to 1
        commit('setQuantity', 1)
        return true
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
    return false
  },
  updateProduct: async ({ state, rootState, commit, dispatch }, product) => {
    const $utils = $nuxt.$store.$utils
    if (state.data) {
      const choices = $utils.copy(state.choices)
      const mods = state.data.mods
      const errors = validateMods(mods, choices)
      if (errors.length > 0) {
        commit('setErrors', errors, { root: true })
        return false
      }
    }
    commit('setLoading', true, { root: true })

    if (state.recipient) {
      product.recipient = state.recipient
    }

    if (state.instructions) {
      product.instructions = state.instructions
    }

    if (!product.product_id && rootState.cart && rootState.cart.products) {
      const cartProduct = rootState.cart.products.find((e) => e.id === product.id)
      if (cartProduct) {
        product.product_id = cartProduct.product_id
      }
    }

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/products`,
        data: product,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        response.data.type = rootState.channel && rootState.channel !== 'default' ? rootState.channel : 'mealtime'
        const cart = response.data
        commit('setCart', cart, { root: true })
        commit('setLoading', false, { root: true })
        let tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
        events.pushEvent('update_to_cart', cart, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.channel)
        return true
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
    return false
  },
  removeProduct: async ({ rootState, commit, dispatch }, product) => {
    commit('setLoading', true, { root: true })

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'delete',
        url: `carts/${rootState.cart.id}/products/${product.id}`,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        response.data.type = rootState.channel && rootState.channel !== 'default' ? rootState.channel : 'mealtime'
        let tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
        events.pushEvent('remove_from_cart', product, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.menu, rootState.channel)
        commit('setCart', response.data, { root: true })
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
  },
  viewProduct: async ({ state, commit, rootState }, product) => {
    let tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
    commit('setProduct', product)
    if (state.selected) {
      const category = rootState.menu && rootState.menu.categories ? rootState.menu.categories.find((c) => c.name === product.category) || {} : {}
      const payload = {
        category: category,
        prod: product,
      }
      events.pushEvent('select_item', payload, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.menu, rootState.channel)
      commit('setSelectedProd', false)
    }
    const has_group_order = rootState.appInfo.group_order ? true : false
    const group_order = rootState.groupOrder && rootState.groupOrder !== null ? 'yes' : 'no'
    events.pushEvent('view_item', product, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.menu, rootState.channel, has_group_order, group_order)
  },
  clearProduct: async ({ commit }) => {
    commit('setProduct', null)
  },
}
